import { useState } from "react";
import { FormControl, TextField } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import useTranslate from "../../../hooks/useTranslate";
import { colorPrimary, colorRed } from "../../../constants/colors";
import { ISliderProps } from "./Slider.props";
import styles from "./Slider.module.scss";

// функция перевода минут в формат HH:MM
const convertMinutesToFormatHHMM = (value: number): string => {
	const correctedTime = value >= 1440 ? 1439 : value;
	let hours: string | number = Math.trunc(correctedTime / 60);
	let minutes: string | number = correctedTime % 60;
	minutes = minutes < 10 ? "0" + minutes : minutes;
	if (hours < 10) hours = "0" + hours;
	else if (hours === 24) hours = "00";
	return hours + ":" + minutes;
};

// функция перевода формата HH:MM в минуты
const convertFormatHHMMToMinutes = (value: string): number => {
	const hours = +(value[0] + value[1]);
	const minutes = +(value[3] + value[4]);
	const times = hours * 60 + minutes;
	return times;
};

const Slider = ({ time, idx, array, changeTimeIntervalHandler, deleteTimeHandler, setChangeFlg, isDisabled }: ISliderProps): JSX.Element => {
	const [startTime, setStartTime] = useState<string>(convertMinutesToFormatHHMM(time[0])); // время начала интервала
	const [endTime, setEndTime] = useState<string>(convertMinutesToFormatHHMM(time[1])); // время конца интервала

	const translate = useTranslate(); // hook для перевода текста

	// обработчик изменения времени
	const changeTimeHandler = (): void => {
		// если были изменения
		if (convertMinutesToFormatHHMM(time[0]) !== startTime || convertMinutesToFormatHHMM(time[1]) !== endTime) {
			const convertedStartTime = convertFormatHHMMToMinutes(startTime); // начальное время в мин
			const convertedEndTime = convertFormatHHMMToMinutes(endTime); // конечное время в мин
			// если начальное время больше или равно конечному

			if (convertedStartTime >= convertedEndTime) {
				setStartTime(endTime);
				changeTimeIntervalHandler([convertedStartTime, convertedEndTime], idx);
			} else {
				changeTimeIntervalHandler([convertedStartTime, convertedEndTime], idx);
			}
			setChangeFlg(true);
		}
	};

	return (
		<div className={styles.sliderBlock}>
			<FormControl fullWidth margin="dense" sx={{ m: 0 }}>
				<TextField
					required
					variant="outlined"
					type="time"
					value={startTime}
					onChange={(e) => setStartTime(e.target.value)}
					onBlur={changeTimeHandler}
					disabled={isDisabled}
					InputProps={{
						style: {
							height: 33,
							fontSize: 13,
							color: colorPrimary,
						},
					}}
					InputLabelProps={{
						style: {
							fontSize: 13,
						},
					}}
					sx={{ '.MuiInputLabel-root[data-shrink="false"]': { top: -8 } }}
				/>
			</FormControl>
			-
			<FormControl fullWidth margin="dense" sx={{ m: 0 }}>
				<TextField
					required
					variant="outlined"
					type="time"
					value={endTime}
					onChange={(e) => setEndTime(e.target.value)}
					onBlur={changeTimeHandler}
					disabled={isDisabled}
					InputProps={{
						style: {
							height: 33,
							fontSize: 13,
							color: colorPrimary,
						},
					}}
					InputLabelProps={{
						style: {
							fontSize: 13,
						},
					}}
					sx={{ '.MuiInputLabel-root[data-shrink="false"]': { top: -8 } }}
				/>
			</FormControl>
			{/* удаление периода */}
			{!isDisabled && array.length > 1 && deleteTimeHandler && (
				<FontAwesomeIcon
					icon={faTrashCan}
					color={colorRed}
					size="lg"
					onClick={() => deleteTimeHandler(idx)}
					title={translate("button_deletePeriod")}
					style={{ cursor: "pointer" }}
				/>
			)}
		</div>
	);
};

export default Slider;
